import moment from 'moment';
import React, { useRef, useState } from 'react'
import Flatpickr from 'react-flatpickr';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { setContentFilters } from 'slices/socialAccounts/reducer';
import { AppDispatch, RootState } from 'store';
import { PostTypeOptionLabel, PostTypeOptions, SocialAccountContentFilters, SortOptionLabel, SortOptions } from 'types/social-account';

const Filters: React.FC<{ justifyContent?: string }> = ({ justifyContent = 'end' }) => {
    const [flatpickr, setFlatPickr] = useState<boolean>(true)
    const filters = useSelector((state: RootState) => state.socialAccountState.content.filters);
    const dispatch: AppDispatch = useDispatch();
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    // const [searchQuery, setSearchQuery] = useState('');


    const setFilters = (updatedFilters: SocialAccountContentFilters) => {
        dispatch(setContentFilters(updatedFilters));
    }


    const getSelectedDate = () => {
        const { start_date, end_date } = filters;
        const dates: Date[] = [];
        if (start_date) dates.push(moment(start_date, 'YYYY-MM-DD').toDate());
        if (end_date) dates.push(moment(end_date, 'YYYY-MM-DD').toDate());
        return dates;
    };

    const handleDateChange = (selectedDates: Date[]) => {
        if (selectedDates.length === 2) {
            setFilters({ ...filters, start_date: moment(selectedDates[0]).format('YYYY-MM-DD'), end_date: moment(selectedDates[1]).format('YYYY-MM-DD') })
        } else if (selectedDates.length === 1) {
            // handleFilterChange('end_date', '');
        } else {
            let updated_filters = { ...filters };
            delete updated_filters.start_date;
            delete updated_filters.end_date;
            setFilters(updated_filters);
        }
    };
    return (
        <div className={`d-flex align-items-center gap-3 justify-content-${justifyContent}`}>
            <div className="position-relative">
                {
                    (filters.start_date || filters.end_date) &&
                    <button onClick={() => {
                        handleDateChange([])
                        setFlatPickr(false);
                        setTimeout(() => {
                            setFlatPickr(true)
                        }, 0)
                    }} className="unset-all text-primary cursor-pointer" style={{ fontSize: '12px', position: 'absolute', top: '6px', right: '6px' }}> <i className="mdi mdi-close fs-5 fw-bold"></i> </button>
                }
                {
                    flatpickr &&
                    <Flatpickr
                        className="border-0 dash-filter-picker filter-date-range performance-date-range-picker form-control"
                        options={{
                            mode: 'range',
                            dateFormat: 'd M, Y',
                        }}
                        style={{ width: '220px' }}
                        {...({ placeholder: "Select Date Range" } as any)}
                        value={getSelectedDate() as unknown as Date}
                        onChange={handleDateChange}
                    />
                }
            </div>

            <UncontrolledDropdown className='sort-dropdown'>
                <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                    <span>
                        <span className='text-muted me-1'>Post Type: </span>
                        {
                            (!filters.type || filters.type === PostTypeOptions.ALL) ? PostTypeOptionLabel[PostTypeOptions.ALL] : PostTypeOptionLabel[filters.type as keyof typeof PostTypeOptionLabel]
                        }
                    </span>
                    <i className='mdi mdi-chevron-down fs-5' />
                </DropdownToggle>
                <DropdownMenu className='mt-1 p-0 w-100'>
                    {
                        Object.values(PostTypeOptions).map((postTypeOption, i) => <DropdownItem key={i} onClick={() => setFilters({ ...filters, ...(postTypeOption === PostTypeOptions.ALL ? { type: null } : { type: postTypeOption }) })}>{PostTypeOptionLabel[postTypeOption]}</DropdownItem>)
                    }
                </DropdownMenu>
            </UncontrolledDropdown>

            <UncontrolledDropdown className='sort-dropdown'>
                <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                    <span>
                        <span className='text-muted me-1'>Sort by: </span>
                        {SortOptionLabel[filters.sort as keyof typeof SortOptionLabel]}
                    </span>
                    <i className='mdi mdi-chevron-down fs-5' />
                </DropdownToggle>
                <DropdownMenu className='mt-1 p-0 w-100'>
                    {
                        Object.values(SortOptions).map((sortOption, i) => <DropdownItem key={i} onClick={() => setFilters({ ...filters, sort: sortOption })}>{SortOptionLabel[sortOption]}</DropdownItem>)
                    }
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    )
}

export default Filters
